<script setup>import { computed as _computed } from 'vue';

  import { groupBorderStyle } from "./serving-size-calculator.js";
  import ServingSizeCategoryList from "./serving-size-category-list.vue";

  const props = defineProps({
    categories: { type: Array, required: true },
    modelValue: { type: String, default: null },
  });

  const emit = defineEmits(["select", "see", "update:model-value"]);

  const selectedGroup = _computed(() => props.modelValue);
  const selectGroup = (group) => emit("update:model-value", group);

  const groups = _computed(() => [
    ...new Set(props.categories.map(({ group }) => group).filter(Boolean)),
  ]);

  const groupCategories = _computed(() => {
    if (!selectedGroup.value) return [];
    return props.categories.filter(({ group }) => group === selectedGroup.value);
  });

  const back = () => emit("update:model-value", null);
</script>

<template>
  <div>
    <template v-if="!groups.length">
      <p class="heading mb-3">All categories</p>
      <ServingSizeCategoryList
        :categories="categories"
        @select="(cat) => emit('select', cat)"
        @see="(term) => emit('see', term)"
      />
    </template>
    <template v-else-if="!selectedGroup">
      <p class="heading mb-3">Browse by group</p>
      <ul class="group-list">
        <li
          v-for="group in groups"
          :key="group"
          :style="groupBorderStyle(group)"
          @click="selectGroup(group)"
        >
          {{ group }}
        </li>
      </ul>
    </template>
    <template v-else>
      <div class="is-flex is-align-items-center mb-3">
        <button class="button is-small mr-2" @click="back">
          <span class="icon is-small">
            <i class="fas fa-arrow-left"></i>
          </span>
        </button>
        <p class="heading mb-0">{{ selectedGroup }}</p>
      </div>
      <ServingSizeCategoryList
        :categories="groupCategories"
        @select="(cat) => emit('select', cat)"
        @see="(term) => emit('see', term)"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
  @import "~/jose_modern/css";

  .group-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 0.75em 1em;
      margin-bottom: 0.5em;
      border-left: 4px solid;
      border-radius: 0 0.35em 0.35em 0;
      background-color: $white-bis;
      cursor: pointer;
      font-weight: 500;
      transition: background-color 0.15s;

      &:hover {
        background-color: $grey-lighter;
      }
    }
  }
</style>
